export class EnaioWorkflowApplicationParameter {
    id = "";
    mode = "";
    index = 0;
}
